import type { InitPlayer, PlayerState } from "../types";

export function normalizeSeatOrder(
  players: readonly InitPlayer[],
  hostPlayerId: string,
): readonly InitPlayer[] {
  const hostIndex = players.findIndex((player) => player.id === hostPlayerId);
  if (hostIndex < 0) {
    throw new Error("Host must be seated");
  }

  return [...players.slice(hostIndex), ...players.slice(0, hostIndex)];
}

export function buildPlayerStates(
  orderedPlayers: readonly InitPlayer[],
): readonly PlayerState[] {
  return orderedPlayers.map((player, index) => ({
    id: player.id,
    name: player.name,
    seatNumber: index + 1,
    startingCardId: null,
    voteTargetId: null,
  }));
}

export function reorderPlayerStates(
  players: readonly PlayerState[],
  seatOrder: readonly string[],
): readonly PlayerState[] {
  const byId = new Map(players.map((player) => [player.id, player]));
  return seatOrder.map((playerId, index) => {
    const player = byId.get(playerId);
    if (!player) {
      throw new Error(`Unknown player id: ${playerId}`);
    }
    return {
      ...player,
      seatNumber: index + 1,
    };
  });
}
